import { localizedGeoCheckEventSource } from "../../intl/shared-resources/geoCheckEventSource.js";
import { ChipVariant, ChipType } from "../../components/chip/types.js";
import { GeoCheckEventSource } from "../../contract/pam.js";
const getGeoCheckEventSourceChipsMapping = () => ({
  [GeoCheckEventSource.Login]: {
    label: localizedGeoCheckEventSource[GeoCheckEventSource.Login],
    chipType: ChipType.Status,
    chipVariant: ChipVariant.DropdownDefault
  },
  [GeoCheckEventSource.Geocomply]: {
    label: localizedGeoCheckEventSource[GeoCheckEventSource.Geocomply],
    chipType: ChipType.Status,
    chipVariant: ChipVariant.DropdownDefault
  }
});
export {
  getGeoCheckEventSourceChipsMapping
};
//# sourceMappingURL=geoCheckEventSourceChipConfig.js.map
